var cifGy = ["301 181", "<g fill='none'><path fill='#009E49' d='M.5.5h300v180H.5z'/><path fill='#FFF' d='M.5.5l300 90-300 90z'/><path fill='#FCD116' d='M.5 8.33L274.1 90.5.5 172.67z'/><path fill='#000' d='M.5.5l150 90-150 90z'/><path fill='#CE1126' d='M.5 11l132.51 79.5L.5 170z'/></g>"];

export { cifGy };

